import { SFX_VOLUME } from '../../data/constants';

// Preloads an audio clip into a HTMLAudioElement. Resolves once the browser
// signals the file is buffered enough to play through (or on error - we still
// return the element so the caller's preload pipeline doesn't hang). A 2s
// safety timeout catches browsers that never fire `canplaythrough`.
export function loadAudio(url: string): Promise<HTMLAudioElement> {
  const audio = new Audio(url);
  audio.preload = 'auto';
  audio.load();
  return new Promise((resolve) => {
    const finish = (): void => {
      audio.removeEventListener('canplaythrough', finish);
      audio.removeEventListener('error', finish);
      resolve(audio);
    };
    audio.addEventListener('canplaythrough', finish, { once: true });
    audio.addEventListener('error', finish, { once: true });
    setTimeout(finish, 2000);
  });
}

// Plays a preloaded clip at the master SFX volume. Clones the source so
// overlapping plays don't cut each other off (browsers reset playback when
// you re-call .play() on the same element). Failures (e.g. autoplay block
// before first user gesture) are swallowed.
export function playSfx(audio: HTMLAudioElement, volumeMul = 1): void {
  const clip = audio.cloneNode(true) as HTMLAudioElement;
  clip.volume = Math.min(1, Math.max(0, SFX_VOLUME * volumeMul));
  clip.play().catch(() => {});
}
